import { render, staticRenderFns } from "./radikalische-substitution-mechanismus.vue?vue&type=template&id=25f88df5&"
import script from "./radikalische-substitution-mechanismus.vue?vue&type=script&lang=js&"
export * from "./radikalische-substitution-mechanismus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports